<svg
    width="80"
    height="67"
    viewBox="0 0 80 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M37.9998 66.8325C54.5303 66.8325 67.9996 53.3813 67.9996 36.8604C67.9439 20.2837 54.5303 6.83252 37.9998 6.83252C21.4137 6.83252 8.00012 20.2837 8.00012 36.8046C8.00012 53.3813 21.4137 66.8325 37.9998 66.8325Z"
        fill="#EAEEF9"
    />
    <path
        d="M74.4867 24.5994C75.9052 24.5994 77.0552 23.4495 77.0552 22.0309C77.0552 20.6124 75.9052 19.4624 74.4867 19.4624C73.0682 19.4624 71.9182 20.6124 71.9182 22.0309C71.9182 23.4495 73.0682 24.5994 74.4867 24.5994Z"
        fill="#EAEEF9"
    />
    <path
        d="M78.246 14.5756C79.2148 14.5756 80.0001 13.7903 80.0001 12.8215C80.0001 11.8527 79.2148 11.0674 78.246 11.0674C77.2773 11.0674 76.4919 11.8527 76.4919 12.8215C76.4919 13.7903 77.2773 14.5756 78.246 14.5756Z"
        fill="#EAEEF9"
    />
    <path
        d="M3.25773 58.9298C5.05685 58.9298 6.51533 57.4713 6.51533 55.6722C6.51533 53.873 5.05685 52.4146 3.25773 52.4146C1.4586 52.4146 0.00012207 53.873 0.00012207 55.6722C0.00012207 57.4713 1.4586 58.9298 3.25773 58.9298Z"
        fill="#EAEEF9"
    />
    <path
        d="M69.3835 56.9055L71.6046 56.2358C71.7655 56.1918 71.7655 55.9571 71.6046 55.9131L69.3835 55.2434C69.3263 55.2239 69.2847 55.1848 69.2695 55.1261L68.6001 52.9115C68.5531 52.7502 68.3194 52.7502 68.2729 52.9115L67.6035 55.1261C67.5878 55.1848 67.5462 55.2239 67.4895 55.2434L65.2733 55.9131C65.1124 55.9571 65.1124 56.1918 65.2733 56.2358L67.4944 56.9055C67.5516 56.9202 67.5932 56.9642 67.6088 57.0228L68.2783 59.2423C68.3248 59.4036 68.5585 59.4036 68.605 59.2423L69.2744 57.0228C69.2847 56.9642 69.3263 56.9202 69.3835 56.9055Z"
        fill="#AAB2C5"
    />
    <g filter="url(#filter0_d_772_7934)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M39.1405 27.8316C38.4619 28.4828 37.3904 28.4828 36.7117 27.8316L35.4973 26.6662C34.0759 25.3021 32.1557 24.4692 30.0336 24.4692C25.6747 24.4692 22.1411 28.0029 22.1411 32.3618C22.1411 36.5407 24.4032 39.9914 27.6689 42.8266C30.9374 45.6642 34.8452 47.5462 37.1801 48.5066C37.6683 48.7075 38.1839 48.7075 38.6721 48.5066C41.007 47.5462 44.9148 45.6642 48.1833 42.8266C51.449 39.9914 53.7112 36.5407 53.7112 32.3618C53.7112 28.0029 50.1776 24.4692 45.8186 24.4692C43.6965 24.4692 41.7763 25.3021 40.3549 26.6662L39.1405 27.8316ZM37.9261 24.1352C35.8778 22.1695 33.0968 20.9614 30.0336 20.9614C23.7374 20.9614 18.6333 26.0656 18.6333 32.3618C18.6333 43.5311 30.8585 49.6992 35.8456 51.7507C37.1887 52.3032 38.6635 52.3032 40.0066 51.7507C44.9937 49.6992 57.219 43.5311 57.219 32.3618C57.219 26.0656 52.1149 20.9614 45.8186 20.9614C42.7555 20.9614 39.9745 22.1695 37.9261 24.1352Z"
            fill="url(#paint0_linear_772_7934)"
        />
    </g>
    <path
        d="M5.24839 27.2841L6.35896 26.9492C6.43941 26.9272 6.43941 26.8098 6.35896 26.7878L5.24839 26.453C5.21979 26.4432 5.19899 26.4237 5.19141 26.3943L4.85667 25.2871C4.8332 25.2064 4.71634 25.2064 4.69311 25.2871L4.35837 26.3943C4.35054 26.4237 4.32975 26.4432 4.30139 26.453L3.19327 26.7878C3.11282 26.8098 3.11282 26.9272 3.19327 26.9492L4.30384 27.2841C4.33244 27.2914 4.35323 27.3134 4.36105 27.3427L4.69579 28.4524C4.71902 28.5331 4.83589 28.5331 4.85912 28.4524L5.19386 27.3427C5.199 27.3134 5.21979 27.2914 5.24839 27.2841Z"
        fill="#DFE4F1"
    />
    <path
        d="M20.7674 3.3063L22.4612 2.7991C22.5835 2.76331 22.5835 2.58436 22.4612 2.54857L20.7674 2.0354C20.7239 2.02347 20.6923 1.9937 20.6803 1.95194L20.1696 0.257463C20.1344 0.138137 19.956 0.138137 19.9208 0.257463L19.4101 1.95194C19.3982 1.9937 19.3666 2.02347 19.323 2.0354L17.6334 2.54857C17.5105 2.58436 17.5105 2.76331 17.6334 2.7991L19.3272 3.3063C19.3708 3.31823 19.4024 3.348 19.4143 3.39573L19.9244 5.09021C19.9602 5.20953 20.138 5.20953 20.1738 5.09021L20.6845 3.39573C20.6923 3.348 20.7239 3.31823 20.7674 3.3063Z"
        fill="#AAB2C5"
    />
    <defs>
        <filter
            id="filter0_d_772_7934"
            x="9.88407"
            y="16.5868"
            width="56.0842"
            height="48.7021"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
            />
            <feOffset dy="4.37461" />
            <feGaussianBlur stdDeviation="4.37461" />
            <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
            />
            <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_772_7934"
            />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_772_7934"
                result="shape"
            />
        </filter>
        <linearGradient
            id="paint0_linear_772_7934"
            x1="37.9292"
            y1="22.0454"
            x2="37.9292"
            y2="39.5597"
            gradientUnits="userSpaceOnUse"
        >
            <stop stop-color="#B0BACC" />
            <stop offset="1" stop-color="#969EAE" />
        </linearGradient>
    </defs>
</svg>
